export default __webpack_public_path__ + "static/media/tomato.6a3abd8a.svg";